import React from 'react';

import { SVGPropsType } from 'src/types';

function SortUp(props: SVGPropsType) {
    const { fill, onClick, style, className } = props;

    return (
        <svg
            width="6"
            height="4"
            viewBox="0 0 6 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M5.29497 3.07653L3.3429 1.26467C3.15029 1.08589 2.84962 1.08589 2.65702 1.26467L0.704947 3.07653L0 2.42076L2.31318 0.268908C2.69855 -0.0896359 3.30122 -0.0896359 3.6866 0.268908L5.99979 2.42076L5.29497 3.07653Z"
                fill={fill}
            />
        </svg>
    );
}

export default SortUp;
